import React from 'react'

const PhoneIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.6666 38.3334C10.75 38.3334 9.96526 38.007 9.31248 37.3542C8.6597 36.7015 8.33331 35.9167 8.33331 35.0001V5.00008C8.33331 4.08341 8.6597 3.29869 9.31248 2.64591C9.96526 1.99314 10.75 1.66675 11.6666 1.66675H28.3333C29.25 1.66675 30.0347 1.99314 30.6875 2.64591C31.3403 3.29869 31.6666 4.08341 31.6666 5.00008V35.0001C31.6666 35.9167 31.3403 36.7015 30.6875 37.3542C30.0347 38.007 29.25 38.3334 28.3333 38.3334H11.6666ZM11.6666 30.0001V35.0001H28.3333V30.0001H11.6666ZM20 34.1667C20.4722 34.1667 20.868 34.007 21.1875 33.6876C21.5069 33.3681 21.6666 32.9723 21.6666 32.5001C21.6666 32.0279 21.5069 31.632 21.1875 31.3126C20.868 30.9931 20.4722 30.8334 20 30.8334C19.5278 30.8334 19.1319 30.9931 18.8125 31.3126C18.493 31.632 18.3333 32.0279 18.3333 32.5001C18.3333 32.9723 18.493 33.3681 18.8125 33.6876C19.1319 34.007 19.5278 34.1667 20 34.1667ZM11.6666 26.6667H28.3333V10.0001H11.6666V26.6667ZM11.6666 6.66675H28.3333V5.00008H11.6666V6.66675Z'
      fill='currentcolor'
    />
  </svg>
)

export default PhoneIcon
